import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import { AlertMessage, ContentContainer, TitleHeader } from "../components/UiComponents";
import { CourseTile } from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function Dashboard() {
	const { state, dispatch, api } = useAppContext();
	const isOffline = state.offline
	const { state: routerState } = useLocation();

	useDocumentTitle('Dashboard');
	// console.log(state.courses)

	useEffect(() => {
		dispatch({ type: 'SET_COURSE', payload: null })
		api.loadCourses()
	}, []);

	useEffect(() => {
		if (routerState?.error) {
			// Clear window state
			window.history.replaceState(null, null, window.location.pathname);
		}
	}, [routerState]);

	const ViewNextWeekButton = () => {
		return (
			<Link to={'/upcoming-courses'} className="btn btn-sm btn-primary">
				Next Week's Courses
			</Link>
		);
	}

	return (
		<div className="dashboard">
			<ContentContainer classes="mb-4">
				{routerState?.error && (
					<div className="mb-3">
						<AlertMessage type="danger" message={routerState?.error} />
					</div>
				)}
				<TitleHeader title="This Week's Courses" rightContent={<ViewNextWeekButton />} />
				{state.courses.length > 0 ? (
					<div className="course-tiles">
						{state.courses.map((course) => (
							<CourseTile course={course} key={course.id} />
						))}
					</div>
				) : (
					<p>You have no courses this week</p>
				)}

			</ContentContainer>
			<ContentContainer classes="mb-4">
				<TitleHeader title="Other Courses" />
				<div className="dashboard__other-courses">
					<div className="mb-3">
						<Link to="/upcoming-courses" className="btn btn-tertiary">
							View Upcoming Courses
						</Link>
					</div>
					{!isOffline && (
						<div>
							<Link to="/teaching-logs" className="btn btn-tertiary">
								Access Teaching Logs
							</Link>
						</div>
					)}
				</div>
			</ContentContainer>
		</div>
	)
}

export default Dashboard;